module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAAAsTAAALEwEAmpwYAAABUElEQVR4nO2Wv0rDUBSHvyxqF4ud1Ih7R/EJ9BUEZ7W7OJmi+Dq6SA24KL6BIv4BoS4q6CIuLRX/gKIEbiAE6zn35jYufvCDkHDOBzcnh8A//akBK0AMtIFnk+R6D1gGxvBIBdgEusCXkA6wYWoKMQkcK4T5nAHTrtIp4MFBmuYeCG2lFeC0gDTNCTBiI97yIE3T1EprykHSpqOd9oZHaZoljTgWmrwD62bik0Tm3m81LY34WmiSiPJEQk1bI+4JTSZ+qBkXanoa8ZvQJDnePKFQ86IR3zkcdVOoudWIW4rhiiyHa1cjXhzA57SgEQ8DTx6lj8AQShplL4+UADjyID0wvawYBS4KSK+K/JGEwKWD9LzP925FFdi3kMbmtLwQAGvAq7CdVl3eqYa62UJ56Y15NlBmgc+M9AOYoSR2MuJtSmQ+I54rUxwAh64L4k/5Bk2pcY91HooZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons8-marker-30.png
// module id = 1LGQ
// module chunks = 4